import { render, staticRenderFns } from "./UsuariosRelEmpresas.vue?vue&type=template&id=60d2562b&"
import script from "./UsuariosRelEmpresas.vue?vue&type=script&lang=js&"
export * from "./UsuariosRelEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosRelEmpresas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports